import React from "react";
import { graphql, HeadProps, PageProps } from "gatsby";

import routes from "../../clhbid-routes";

import SEO from "../components/SEO";
import SaleNav from "../components/SaleNav";

import SaleOverview from "../sections/SaleOverview";
import SaleDetails from "../sections/SaleDetails";
import SaleParcels from "../sections/SaleParcels";
import RegisterCTA from "../sections/RegisterCTA";
import BuyerTestimonials from "../sections/BuyerTestimonials";
import SaleDescription from "../sections/SaleDescription";
import SaleFAQ from "../sections/SaleFAQ";
import BiddingVideo from "../sections/BiddingVideo";
import UpcomingSales from "../sections/UpcomingSales";

const SaleTemplate: React.FC<PageProps<Queries.SaleTemplateQuery>> = ({
  data: { sale, upcomingSales },
}) => {
  const hasMultipleParcels = (sale.parcels?.length ?? 0) > 1;
  const hasOptions = sale.options?.length;
  const hasParcelFeatures = sale.parcels?.some(
    (parcel) => parcel.features?.length
  );
  const showSaleParcels = hasMultipleParcels || hasOptions || hasParcelFeatures;

  return (
    <div className="pt-14 lg:pt-10">
      <SaleNav sale={sale} />
      <SaleOverview sale={sale} />
      {showSaleParcels ? (
        <SaleParcels sale={sale} />
      ) : (
        <SaleDetails sale={sale} />
      )}
      <SaleDescription sale={sale} />
      <BuyerTestimonials />
      <SaleFAQ />
      <RegisterCTA />
      <BiddingVideo />
      <UpcomingSales sales={upcomingSales.nodes} />
    </div>
  );
};

export const Head: React.FC<HeadProps<Queries.SaleTemplateQuery>> = ({
  data: { sale },
}) => (
  <SEO
    title={sale.name}
    description={sale.summary.summary}
    image={sale.saleImage?.url}
    url={routes.sale.details(sale)}
  />
);

export const query = graphql`
  query SaleTemplate($slug: String) {
    sale: contentfulSale(slug: { eq: $slug }) {
      name
      slug
      summary {
        summary
      }
      saleImage {
        url
      }
      ...SaleNavSale
      ...SaleOverviewSale
      ...SaleDetailsSale
      ...SaleParcelsSale
      ...SaleDescriptionSale
    }
    upcomingSales: allContentfulSale(
      sort: { parcels: { startTime: ASC } }
      filter: { slug: { ne: $slug }, saleStatus: { ne: "completed" } }
      limit: 4
    ) {
      nodes {
        ...UpcomingSalesSale
      }
    }
  }
`;

export default SaleTemplate;
